import {
  examList,
  examAdd,
  examEdit,
  examDelete,
} from '@/api/exam'

export default {
  async examList({ }, data) {
    return examList(data)
  },
  async examAdd({ }, data) {
    return examAdd(data)
  },
  async examEdit({ }, data) {
    return examEdit(data)
  },
  async examDelete({ }, data) {
    return examDelete(data)
  },
}
